module.exports = __webpack_public_path__ + "plugins/web/img/小智分析.eee5885d.png";